export default __webpack_public_path__ + "static/media/file-text.f917fad6.svg";